import request from '@/common/request';

export function fetchConstants() {
	return request.get('/constant');
}
